var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYfslabelProductIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 78,
    viewBox: "0 0 81 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.2028 39.2459C80.9567 90.8984 -0.178171 90.8987 0.582463 39.2423C-0.17174 -12.4066 80.9632 -12.4069 80.2028 39.2459Z",
    fill: "#203669"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3927 22.303C44.5787 22.303 47.9692 25.3613 47.9692 29.1371C47.9692 30.3843 47.6093 31.5461 46.9464 32.5541H51.7574C53.5568 32.5541 55.072 33.6988 55.4509 35.2194C59.258 48.9046 59.3338 49.2634 59.3338 49.6393C59.3338 51.5186 57.6291 53.0563 55.5456 53.0563H25.2399C23.1564 53.0563 21.4517 51.5186 21.4517 49.6393C21.4517 49.2634 21.5274 48.9046 25.3346 35.2194C25.7134 33.6988 27.2287 32.5541 29.0281 32.5541H33.8391C33.1762 31.5461 32.8163 30.3843 32.8163 29.1371C32.8163 25.3613 36.2067 22.303 40.3927 22.303ZM40.3927 25.7201C38.3092 25.7201 36.6045 27.2577 36.6045 29.1371C36.6045 31.0165 38.3092 32.5541 40.3927 32.5541C42.4762 32.5541 44.181 31.0165 44.181 29.1371C44.181 27.2577 42.4762 25.7201 40.3927 25.7201Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYfslabelProductIcon);
export default __webpack_public_path__ + "static/media/yfslabel_product_icon.acd64b63db02afd877ff2ea69845c2b7.svg";
export { ForwardRef as ReactComponent };